import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { LoginRequiredBadge, PlatformBadge } from './badges';
import { IOfferBadgesProps } from './types';

export const BadgeContentContainer = styled.div`
  flex-grow: 0;
  margin-top: -0.75rem;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const OfferBadges: React.FC<IOfferBadgesProps> = ({
  className,
  platforms,
  displayLoginRequiredBadge,
}) => {
  const { formatMessage } = useIntl();

  return (
    <BadgeContentContainer className={className}>
      {platforms.length === 1 &&
        platforms.map(platform => (
          <PlatformBadge platform={platform} formatMessage={formatMessage} key={platform} />
        ))}
      {displayLoginRequiredBadge && <LoginRequiredBadge formatMessage={formatMessage} />}
    </BadgeContentContainer>
  );
};
